import { calcServiceTotalPrice, serviceHasNotEnoughMaterial } from '@/composables/serviceHelper'
import { mixins } from '@/mixins'

export const complexHasNotEnoughMaterial = (services, complexCount = 1) => {
  let has = false
  if (services && services.length) {
    services.forEach(s => has = !has ? serviceHasNotEnoughMaterial(s, complexCount * s.total_count) : has)
  }
  return has
}

export const needRecalculateComplexPrice = c => {
  let need = false
  if (c && c.dental_services) {
    c.dental_services.map(ds => {
      if (ds.consumption_rate && !need) {
        need = !!ds.consumption_rate.find(cr => cr.recalculate_price_info && cr.recalculate_price_info.need_recalculate)
      }
    })
  }
  return need
}

export const getComplexServiceMaterialWarnings = c => {
  const warnings = []
  if (c && c.dental_services) {
    c.dental_services.map(ds => {
      if (ds && ds.consumption_rate) {
        if (ds.consumption_rate.find(cr => cr.recalculate_price_info && cr.recalculate_price_info.changed_price)) {
          let text = 'имеется материал с измененной ценой партии'
          if (!warnings.includes(text)) {
            warnings.push(text)
          }
        }
        if (
          ds.consumption_rate.find(cr => cr.recalculate_price_info && cr.recalculate_price_info.not_enough_material)
        ) {
          let text = 'имеется израсходованный материал'
          if (!warnings.includes(text)) {
            warnings.push(text)
          }
        }
      }
    })
    if (warnings.length === 1) {
      warnings[0] = mixins.methods.capitalizeFirstLetter(warnings[0])
    }
  }
  return warnings
}

export const calcComplexTotalPrice = c => {
  let total = 0
  const complexCount = c.hasOwnProperty('system_column_count') ? c.system_column_count : 1
  if (c.dental_services && c.dental_services.length) {
    c.dental_services.map(s => {
      let totalServicePricePerUnit = calcServiceTotalPrice(s)
      if (totalServicePricePerUnit && c.calc_discount_percent) {
        totalServicePricePerUnit = totalServicePricePerUnit - (
          (totalServicePricePerUnit / 100) * c.calc_discount_percent
        )
      }
      total += parseFloat(mixins.methods.formatPrice(totalServicePricePerUnit * s.total_count, false))
    })
  }
  total *= parseFloat(complexCount)
  return total
}
